export default __webpack_public_path__ + "assets/images/portrait_youth_male_38.jpg";